import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { VisuallyHidden } from "../VisuallyHidden/VisuallyHidden.js";
import { Spinner } from "../Spinner/Spinner.js";
/* empty css           */
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Button/Button.tsx
function renderIcon(icon, className) {
	if (icon === void 0) return null;
	return /* @__PURE__ */ jsx("span", {
		className,
		"aria-hidden": "true",
		children: typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon }) : icon
	});
}
/**
* A button in one of five variants and three sizes, with optional icons and a loading
* state. Native button semantics; `type` defaults to `button`.
*/
var Button = forwardRef(function Button({ variant = "primary", size = "md", leadingIcon, trailingIcon, iconOnly = false, block = false, loading = false, loadingText, type = "button", className, children, onClick, ...rest }, ref) {
	const handleClick = (event) => {
		if (loading) {
			event.preventDefault();
			return;
		}
		onClick?.(event);
	};
	const hasLoadingText = loadingText !== void 0 && loadingText !== null && !iconOnly;
	const label = iconOnly ? null : /* @__PURE__ */ jsx("span", {
		className: "ds-button__text",
		children
	});
	return /* @__PURE__ */ jsxs("button", {
		ref,
		type,
		className: cx("ds-button", `ds-button--${variant}`, `ds-button--${size}`, iconOnly && "ds-button--icon-only", block && "ds-button--block", loading && "ds-button--loading", className),
		"aria-busy": loading || void 0,
		onClick: handleClick,
		...rest,
		children: [/* @__PURE__ */ jsxs("span", {
			className: "ds-button__content",
			children: [/* @__PURE__ */ jsxs("span", {
				className: "ds-button__face",
				"data-hidden": loading || void 0,
				"aria-hidden": loading || void 0,
				children: [
					renderIcon(leadingIcon, "ds-button__icon"),
					label,
					renderIcon(trailingIcon, "ds-button__icon")
				]
			}), (loading || hasLoadingText) && /* @__PURE__ */ jsxs("span", {
				className: "ds-button__face",
				"data-hidden": !loading || void 0,
				"aria-hidden": !loading || !hasLoadingText || void 0,
				children: [/* @__PURE__ */ jsx(Spinner, {
					label: "",
					className: "ds-button__icon"
				}), hasLoadingText && /* @__PURE__ */ jsx("span", {
					className: "ds-button__text",
					children: loadingText
				})]
			})]
		}), loading && !hasLoadingText && !iconOnly && /* @__PURE__ */ jsxs(VisuallyHidden, { children: [children, " Loading"] })]
	});
});
//#endregion
export { Button };

//# sourceMappingURL=Button.js.map